import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-responsive-modal';
import { Phone, NotPhone } from '../../utils/styles';
import ProductReview from './ProductReview';
import './StackedModals.css';

const OFFSET = 8;	// This is the vertical offset between each modal

export default class StackedModals extends Component {
	constructor(props) {
		super(props);
		this.state = {
			closedModals: {},
			hideModal: false
		};

		this.onCloseModal = this.onCloseModal.bind(this);
		this.modalOffsets = this.generateModalOffsets(this.props.products.length);
	}

	componentWillReceiveProps(nextProps) {
		this.setState({ closedModals: {}});
		this.modalOffsets = this.generateModalOffsets(nextProps.products.length);
	}

	generateModalOffsets(numOfModals) {
		let numOfOffsets = numOfModals;
		if (numOfOffsets % 2 === 0) {
			numOfOffsets += 1;
		}
		const mid = Math.floor(numOfOffsets / 2);
		let offsets = [];
		for (let i = 0; i < numOfOffsets; i++) {
			offsets.push(OFFSET * (mid - i));
		}
		return offsets;
	}

	onCloseModal(idx) {
		const closedModals = this.state.closedModals;
		closedModals[idx] = true;
		this.setState({ closedModals: closedModals, hideModal: true });
		if (Object.keys(closedModals).length === this.props.products.length) {
			this.props.getProductsForReview();
		}
	}

	render() {
		const closedModals = this.state.closedModals;
		const modals = this.props.products.map((product, idx) =>
			<Modal key={ idx } open={ !closedModals[idx] } onClose={() => this.onCloseModal(idx)} little
				classNames={{ overlay: 'stacked-modal-overlay', modal: 'stacked-modal' }}
				closeOnEsc={ false } closeOnOverlayClick={ false } styles={{ modal: { marginTop: this.modalOffsets[idx] + 'px' }}}>
				<ProductReview product={ product } closeModal={() => this.onCloseModal(idx)} />
			</Modal>
		);
		const modalsMobile = this.props.products.map((product, idx) =>
			<Modal key={ idx } open={ !closedModals[idx] } onClose={() => this.onCloseModal(idx)} little
				classNames={{ overlay: 'stacked-modal-overlay', modal: 'stacked-modal' }}
				closeOnEsc={ false } closeOnOverlayClick={ false } >
				<ProductReview product={ product } closeModal={() => this.onCloseModal(idx)} />
			</Modal>
		);
		return (
			<div className={!this.state.hideModal && !(this.props.products.length < 1) ? "stacked-modals" : "stacked-modals hidden"}>
				<NotPhone>{ modals }</NotPhone>
				<Phone>{ modalsMobile }</Phone>
			</div>
		);
	}
}

StackedModals.propTypes = {
	products: PropTypes.array.isRequired,
	getProductsForReview: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/components/skinprofile/StackedModals.js